import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const RequestMarriage = () => {
  const { language } = useLanguage();
  
  const [formData, setFormData] = useState({
    // Applicant Information
    applicantName: '',
    mobileNumber: '',
    
    // Marriage Certificate Details
    husbandName: '',
    marriageDate: '',
    marriagePlace: '',
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({
        ...formData,
        [name]: files[0]
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission logic here
  };

  const handleReset = () => {
    setFormData({
      applicantName: '',
      mobileNumber: '',
      husbandName: '',
      marriageDate: '',
      marriagePlace: '',
    });
  };

  const formSectionStyle = {
    background: 'linear-gradient(135deg, #fff9f0 0%, #ffe8cc 100%)',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    border: '2px solid #ffa94d',
    boxShadow: '0 4px 12px rgba(255, 169, 77, 0.1)',
  };

  const inputStyle = {
    background: '#ffffff',
    border: '2px solid #ffa94d',
    borderRadius: '8px',
    padding: '12px 16px',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    width: '100%',
  };

  const labelStyle = {
    color: '#d9480f',
    fontSize: '15px',
    fontWeight: '700',
    marginBottom: '10px',
    display: 'block',
    letterSpacing: '0.5px',
  };

  const sectionTitleStyle = {
    color: '#d9480f',
    fontSize: '22px',
    fontWeight: '800',
    marginBottom: '24px',
    paddingBottom: '12px',
    borderBottom: '3px solid #ffa94d',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    position: 'relative',
  };

  const requiredStar = {
    color: '#e03131',
    marginLeft: '3px',
    fontWeight: 'bold',
  };

  const marriageSectionStyle = {
    background: 'linear-gradient(135deg, #e6f3ff 0%, #cce7ff 100%)',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    border: '2px solid #339af0',
    boxShadow: '0 4px 12px rgba(51, 154, 240, 0.1)',
  };

  const marriageSectionTitle = {
    color: '#1864ab',
    fontSize: '22px',
    fontWeight: '800',
    marginBottom: '24px',
    paddingBottom: '12px',
    borderBottom: '3px solid #339af0',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-red-50 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Form Header with Marriage Theme */}
        <div className="text-center mb-10">
          <div className="flex justify-center items-center mb-4">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-pink-500 to-red-500 flex items-center justify-center mr-4">
              <span className="text-3xl text-white">❤️</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-red-800" style={{ textShadow: '2px 2px 4px rgba(220, 38, 38, 0.2)' }}>
              {language === 'marathi' ? 'विवाह दाखला मागणी' : 'Marriage Certificate Request'}
            </h1>
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center ml-4">
              <span className="text-3xl text-white">💑</span>
            </div>
          </div>
          <p className="text-red-600 text-lg font-medium">
            {language === 'marathi' ? 'ई-ग्राम पोर्टल - इनाम धामणी ग्रामपंचायत' : 'E-Gram Portal - Inam Dhamani Gram Panchayat'}
          </p>
          <div className="mt-4 w-32 h-1 bg-gradient-to-r from-pink-500 via-red-500 to-purple-500 mx-auto rounded-full"></div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          {/* Section 1: Applicant Information */}
          <div style={formSectionStyle}>
            <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'अर्जदार माहिती तपशील' : 'Applicant Information Details'}</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'अर्जदार नाव' : 'Applicant Name'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantName"
                  value={formData.applicantName}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'श्री. / सुश्री. / कु. पूर्ण नाव' : 'Mr. / Ms. / Miss. Full Name'}
                  className="focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                />
              </div>

              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'मोबाईल नंबर' : 'Mobile Number'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? '९८७६५४३२१०' : '9876543210'}
                  pattern="[0-9]{10}"
                  className="focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                />
              </div>
            </div>
          </div>

          {/* Section 2: Marriage Certificate Details */}
          <div style={marriageSectionStyle}>
            <h2 style={marriageSectionTitle}>{language === 'marathi' ? 'विवाह दाखला मागणी तपशील' : 'Marriage Certificate Request Details'}</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'पतीचे नाव' : 'Husband\'s Name'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="husbandName"
                  value={formData.husbandName}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'पतीचे संपूर्ण नाव' : 'Husband\'s Full Name'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'विवाह दिनांक' : 'Marriage Date'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="date"
                  name="marriageDate"
                  value={formData.marriageDate}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div className="md:col-span-2">
                <label style={labelStyle}>
                  {language === 'marathi' ? 'विवाह ठिकाण' : 'Marriage Place'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="marriagePlace"
                  value={formData.marriagePlace}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'विवाह ठिकाण (शहर/गाव/मंदिर इ.)' : 'Marriage Place (City/Village/Temple etc.)'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Form Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-6 pt-8">
            <button
              type="submit"
              style={{
                background: 'linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%)',
                color: 'white',
                padding: '16px 40px',
                borderRadius: '10px',
                fontWeight: '700',
                fontSize: '18px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 6px 20px rgba(255, 107, 107, 0.4)',
                letterSpacing: '0.5px',
              }}
              className="hover:shadow-xl transform hover:-translate-y-1 hover:scale-105 transition-transform"
            >
              💖 {language === 'marathi' ? 'विवाह दाखला मागवा' : 'Request Marriage Certificate'}
            </button>

            <button
              type="button"
              onClick={handleReset}
              style={{
                background: 'linear-gradient(135deg, #4dabf7 0%, #339af0 100%)',
                color: 'white',
                padding: '16px 40px',
                borderRadius: '10px',
                fontWeight: '700',
                fontSize: '18px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 6px 20px rgba(77, 171, 247, 0.4)',
                letterSpacing: '0.5px',
              }}
              className="hover:shadow-xl transform hover:-translate-y-1 hover:scale-105 transition-transform"
            >
              🔄 {language === 'marathi' ? 'पुन्हा सुरू करा' : 'Reset'}
            </button>
          </div>

          {/* Form Footer */}
          <div className="mt-10 p-6 bg-gradient-to-r from-pink-50 to-red-50 border-2 border-red-200 rounded-xl">
            <h3 className="text-xl font-bold text-red-800 mb-4 text-center">💝 {language === 'marathi' ? 'महत्वाची सूचना:' : 'Important Notice:'}</h3>
            <ul className="list-disc pl-6 space-y-3 text-red-700">
              <li className="font-medium">{language === 'marathi' ? 'सर्व माहिती अचूक आणि सत्य असल्याची खात्री करा' : 'Ensure all information is accurate and true'}</li>
              <li className="font-medium">{language === 'marathi' ? 'अर्ज सादर केल्यानंतर 7-10 कामकाजाच्या दिवसात विवाह दाखला तयार होईल' : 'Marriage certificate will be ready in 7-10 working days after application'}</li>
              <li className="font-medium">{language === 'marathi' ? 'दाखला घेण्यासाठी मूळ कागदपत्रे आणि प्रमाणपत्रे आणणे अनिवार्य आहे' : 'It is mandatory to bring original documents and certificates to collect the certificate'}</li>
              <li className="font-medium">{language === 'marathi' ? 'विवाह दाखल्याची फी ₹100/- आहे' : 'Marriage certificate fee is ₹100/-'}</li>
              <li className="font-medium">{language === 'marathi' ? 'कोणतीही समस्या असल्यास, ग्रामसेवक कार्यालयात संपर्क साधा' : 'In case of any issues, contact the Gram Sevak office'}</li>
            </ul>
            <div className="mt-4 text-center">
              <p className="text-red-600 font-bold">
                <span style={{color: '#e03131', fontWeight: 'bold'}}>*</span> {language === 'marathi' ? 'हे चिन्ह असलेले फील्ड अनिवार्य आहेत' : 'Fields marked with this symbol are mandatory'}
              </p>
            </div>
          </div>
        </form>

        {/* Wedding Quote */}
        <div className="mt-10 text-center">
          <div className="inline-block p-6 bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl border-2 border-purple-300">
            <p className="text-purple-800 text-lg font-semibold italic">
              {language === 'marathi' 
                ? '"विवाह हे केवळ दोन व्यक्तींचे एकत्रीकरण नाही, तर दोन आत्म्यांची शाश्वत बंधन आहे"'
                : '"Marriage is not just the union of two individuals, but the eternal bond of two souls"'}
            </p>
            <p className="text-gray-600 mt-2">{language === 'marathi' ? '- इनाम धामणी ग्रामपंचायत' : '- Inam Dhamani Gram Panchayat'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestMarriage;